// SPDX-FileCopyrightText: Copyright (c) 2025-2026 provide.io llc. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
let _setupError = null;
const _state = {
    logsEmitted: 0,
    logsDropped: 0,
    tracesEmitted: 0,
    tracesDropped: 0,
    metricsEmitted: 0,
    metricsDropped: 0,
    exportFailuresLogs: 0,
    exportFailuresTraces: 0,
    exportFailuresMetrics: 0,
    retriesLogs: 0,
    retriesTraces: 0,
    retriesMetrics: 0,
    exportLatencyMsLogs: 0,
    exportLatencyMsTraces: 0,
    exportLatencyMsMetrics: 0,
    asyncBlockingRiskLogs: 0,
    asyncBlockingRiskTraces: 0,
    asyncBlockingRiskMetrics: 0,
};
const _defaultCircuitState = {
    state: 'closed',
    openCount: 0,
    cooldownRemainingMs: 0,
};
let _circuitStateFn = () => _defaultCircuitState;
/** Called by resilience module to register the getCircuitState function. */
export function _registerCircuitStateFn(fn) {
    _circuitStateFn = fn;
}
export function getHealthSnapshot() {
    const csLogs = _circuitStateFn('logs');
    const csTraces = _circuitStateFn('traces');
    const csMetrics = _circuitStateFn('metrics');
    return {
        logsEmitted: _state.logsEmitted,
        logsDropped: _state.logsDropped,
        exportFailuresLogs: _state.exportFailuresLogs,
        retriesLogs: _state.retriesLogs,
        exportLatencyMsLogs: _state.exportLatencyMsLogs,
        asyncBlockingRiskLogs: _state.asyncBlockingRiskLogs,
        circuitStateLogs: csLogs.state,
        circuitOpenCountLogs: csLogs.openCount,
        tracesEmitted: _state.tracesEmitted,
        tracesDropped: _state.tracesDropped,
        exportFailuresTraces: _state.exportFailuresTraces,
        retriesTraces: _state.retriesTraces,
        exportLatencyMsTraces: _state.exportLatencyMsTraces,
        asyncBlockingRiskTraces: _state.asyncBlockingRiskTraces,
        circuitStateTraces: csTraces.state,
        circuitOpenCountTraces: csTraces.openCount,
        metricsEmitted: _state.metricsEmitted,
        metricsDropped: _state.metricsDropped,
        exportFailuresMetrics: _state.exportFailuresMetrics,
        retriesMetrics: _state.retriesMetrics,
        exportLatencyMsMetrics: _state.exportLatencyMsMetrics,
        asyncBlockingRiskMetrics: _state.asyncBlockingRiskMetrics,
        circuitStateMetrics: csMetrics.state,
        circuitOpenCountMetrics: csMetrics.openCount,
        setupError: _setupError,
    };
}
export function setSetupError(error) {
    _setupError = error;
}
export function _incrementHealth(field, by = 1) {
    _state[field] += by;
}
/** Map a signal name to the per-signal emitted field. */
export function _emittedField(signal) {
    if (signal === 'traces')
        return 'tracesEmitted';
    if (signal === 'metrics')
        return 'metricsEmitted';
    return 'logsEmitted';
}
/** Map a signal name to the per-signal dropped field. */
export function _droppedField(signal) {
    if (signal === 'traces')
        return 'tracesDropped';
    if (signal === 'metrics')
        return 'metricsDropped';
    return 'logsDropped';
}
/** Map a signal name to the per-signal export-failures field. */
export function _exportFailuresField(signal) {
    if (signal === 'traces')
        return 'exportFailuresTraces';
    if (signal === 'metrics')
        return 'exportFailuresMetrics';
    return 'exportFailuresLogs';
}
/** Map a signal name to the per-signal retries field. */
export function _retriesField(signal) {
    if (signal === 'traces')
        return 'retriesTraces';
    if (signal === 'metrics')
        return 'retriesMetrics';
    return 'retriesLogs';
}
/** Map a signal name to the per-signal export latency field. */
export function _exportLatencyField(signal) {
    if (signal === 'traces')
        return 'exportLatencyMsTraces';
    if (signal === 'metrics')
        return 'exportLatencyMsMetrics';
    return 'exportLatencyMsLogs';
}
export function _recordExportLatency(signal, ms) {
    _state[_exportLatencyField(signal)] = ms;
}
export function _resetHealthForTests() {
    _state.logsEmitted = 0;
    _state.logsDropped = 0;
    _state.tracesEmitted = 0;
    _state.tracesDropped = 0;
    _state.metricsEmitted = 0;
    _state.metricsDropped = 0;
    _state.exportFailuresLogs = 0;
    _state.exportFailuresTraces = 0;
    _state.exportFailuresMetrics = 0;
    _state.retriesLogs = 0;
    _state.retriesTraces = 0;
    _state.retriesMetrics = 0;
    _state.exportLatencyMsLogs = 0;
    _state.exportLatencyMsTraces = 0;
    _state.exportLatencyMsMetrics = 0;
    _state.asyncBlockingRiskLogs = 0;
    _state.asyncBlockingRiskTraces = 0;
    _state.asyncBlockingRiskMetrics = 0;
    _setupError = null;
}
